module.exports = __webpack_public_path__ + "static/media/phylopsy-logo.142da80b.svg";